module.exports = __webpack_public_path__ + "fonts/dxiconsmaterial.403ac720.woff2";